export const inputType = {
    standard: "standard",
    required: "required",
    editOnBlur: "editOnBlur",
    buttonAction: "buttonAction"
}